import StationType from "enums/station-type";
import StationStatusEnum from "enums/station-status";
import { Island, Region } from "assets";

export const initialFilterState = () => {
  return {
    searchKey: "",
    page: 1,
    perPage: 10,
    stationType: {
      isSelectedAll: true,
      value: Object.values(StationType).map((stationType) => ({
        label: stationType,
        value: stationType,
      })),
    },
    status: {
      isSelectedAll: true,
      value: Object.values(StationStatusEnum).map((stationStatus) => ({
        label: stationStatus,
        value: stationStatus,
      })),
    },
    island: {
      isSelectedAll: true,
      value: Object.values(Island).map((island) => ({
        label: island.label,
        value: island.value,
      })),
    },
    region: {
      isSelectedAll: true,
      value: Object.values(Region).map((region) => ({
        label: region.label,
        value: region.value,
      })),
    },
  };
};
